import { Box, Chip, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { OnlinePaymentStatus } from "api";
import { dot } from "utils/animations";

export const PaymentStatusChip = ({
  status,
}: {
  status: OnlinePaymentStatus;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const chipProps = (): {
    label: string;
    color: "success" | "error" | "info" | "warning" | "primary";
  } => {
    switch (status) {
      case OnlinePaymentStatus.Successful:
        return {
          label: t("examCard.statusPaid"),
          color: "success",
        };
      case OnlinePaymentStatus.Failed:
      case OnlinePaymentStatus.Abandoned:
        return {
          label: t("examCard.statusFailed"),
          color: "error",
        };

      case OnlinePaymentStatus.Initialized:
        return {
          label: t("examCard.statusProcessing"),
          color: "primary",
        };
      case OnlinePaymentStatus.NotStarted:
      default:
        return {
          label: t("examCard.statusUnpaid"),
          color: "warning",
        };
    }
  };

  const { label, color } = chipProps();

  return (
    <Chip
      size="small"
      icon={
        <Box
          component="span"
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: theme.palette[color].main,
            ml: "4px !important",
            animation:
              status === OnlinePaymentStatus.Initialized
                ? `${dot} 1.4s infinite ease-in-out`
                : undefined,
          }}
        />
      }
      label={label}
      color={color}
      sx={{
        px: 1,
        fontWeight: 600,
        ".MuiChip-label": { pl: 2 },
      }}
      variant="colored"
    />
  );
};
